import { post } from '@/fn/ajax'
import { User, School, Language } from '@/util/types'

export interface LoginData {
  uname: string
  pwd: string
}

export interface LoginResult {
  user: User
  school: School
  lang: Language
  help: string
}
export interface ActivationData {
  username: string,
  password: string,
  password_second: string,
  code: string,
}

/**
 * 登录接口
 *
 * http://showdoc.growlib.cn/web/#/9?page_id=206
 *
 * 900: 用户不存在
 * 901: 密码不正确
 * @param data 登录数据
 */
export async function login(data: LoginData) {
  const { data: result } = await post('/api/auth/login', data)
  return result as LoginResult
}

// 激活接口
export async function accountActivation(data: ActivationData) {
  const { data: result } = await post('/api/auth/accountActivation', data)
  return result
}

